import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        ",
        "\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { ImageWithFocalPoint, Theme, Subtitle as SubtitleComponent } from "@silvertours/front-shared";
import Image from "next/image";
import { transparentize } from "polished";
import { css } from "@emotion/react";
export var LinkGridContainer = /*#__PURE__*/ styled("div", {
    target: "e6n7wp40"
})("display:grid;grid-template-rows:auto;grid-template-columns:repeat(12,minmax(0,1fr));gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";}");
var getLayoutProperty = function(value) {
    if (typeof value === "number") {
        // Only column value provided
        return /*#__PURE__*/ css("grid-column:span ", value, " / span ", value, ";");
    }
    var _value = _sliced_to_array(value, 2), column = _value[0], row = _value[1];
    return /*#__PURE__*/ css("grid-column:span ", column, " / span ", column, ";grid-row:span ", row, " / span ", row, ";");
};
var makeLayout = function(param, theme) {
    var _param = _sliced_to_array(param, 2), baseValue = _param[0], responsive = _param[1];
    return /*#__PURE__*/ css(getLayoutProperty(baseValue), ";", responsive && Object.entries(responsive).map(function(param) {
        var _param = _sliced_to_array(param, 2), breakpoint = _param[0], value = _param[1];
        return css(_templateObject(), theme.mq(breakpoint), getLayoutProperty(value));
    }));
};
export var Anchor = /*#__PURE__*/ styled("a", {
    target: "e6n7wp41"
})("display:", function(param) {
    var hidden = param.hidden;
    return hidden ? "none" : "flex";
}, ";align-items:flex-end;position:relative;height:100%;min-height:164px;overflow:hidden;border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";background-color:", function(param) {
    var bgColor = param.bgColor, theme = param.theme;
    return theme.color[bgColor];
}, ";text-decoration:none;", function(param) {
    var layout = param.layout, theme = param.theme;
    return makeLayout(layout, theme);
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{min-height:200px;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{min-height:250px;}");
export var StyledImage = /*#__PURE__*/ styled(Image, {
    target: "e6n7wp42"
})("width:100%;transition:transform 0.3s ease;", Anchor, ":hover &{transform:scale(1.1);}");
export var StyledImageWithFocalPoint = /*#__PURE__*/ styled(ImageWithFocalPoint, {
    target: "e6n7wp43"
})("width:100%;transition:transform 0.3s ease;", Anchor, ":hover &{transform:scale(1.1);}");
export var GradientBackground = /*#__PURE__*/ styled("span", {
    target: "e6n7wp44"
})("display:inline-block;width:100%;z-index:10;background-image:", function(param) {
    var theme = param.theme;
    return Theme.getLinearGradient({
        from: transparentize(0.5, theme.color.natural100 || "#000"),
        to: transparentize(1, theme.color.natural100 || "#000")
    }, "to top");
}, ";");
export var Container = /*#__PURE__*/ styled("div", {
    target: "e6n7wp45"
})("position:relative;");
export var Subtitle = /*#__PURE__*/ styled(SubtitleComponent, {
    target: "e6n7wp46"
})("display:block;margin-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";word-break:break-word;padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";transition:transform 0.3s ease;/* Styles on hover */\n  ", Anchor, ":hover &{transform:translateY(-20px);/* Translate on hover */}");
